import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { FontSizeSelect as LocalFontSizeSelect } from '../../components/FontSizeSelect'

export const FontSizeSelect = connect(
  LocalFontSizeSelect,
  mapReadPretty(LocalFontSizeSelect, { disabled: true })
)
